export var VL_ONLY_GUIDE_CONFIG = ['shortTimeLabels'];
//# sourceMappingURL=guide.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/build/src/guide.js
// module id = 940
// module chunks = 0